import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { Text } from '../../typography';
import { SPACINGS } from '../../utils';
import { IconStar } from '../../icons';

const DetailsListStyled = styled.table`
  padding: 0;
  margin: 0;
  border-collapse: collapse;
  width: 100%;

  tr,
  td {
    padding: 0;
    margin: 0;
    vertical-align: center;
  }

  .item {
    color: red;
    border-bottom: 1px solid ${(p) => p.theme.colors.secondary90w};

    &:last-child {
      border-bottom: none;
    }

    .cell {
      padding: ${SPACINGS[2]} 0;
      height: 60px;
    }

    .label {
      white-space: nowrap;
      min-width: 180px;
      padding-right: ${SPACINGS[6]};
      width: 1%;

      ${(p) => p.theme.mediaQueries.isMobile} {
        min-width: 120px;
        padding-right: ${SPACINGS[4]};
      }
    }
  }
`;

type Item = {
  label: string;
  value: string | number | React.ReactNode;
  favorite?: boolean;
};

type DetailsListProps = {
  items: (Item | undefined | false)[];
  style?: React.CSSProperties;
  cellStyle?: React.CSSProperties;
};

function DetailsList(props: DetailsListProps) {
  const { items, style, cellStyle } = props;
  const theme = useTheme();

  return (
    <DetailsListStyled style={style}>
      <tbody>
        {items.map((item, i) => {
          if (!item) return null;

          const value =
            typeof item.value === 'number' ? String(item.value) : item.value;
          return (
            <tr key={i} className="item">
              <td className="label cell" style={cellStyle}>
                <Text type="label" size="sm" margin="none" htmlFor={item.label}>
                  {item.label}
                </Text>
              </td>
              <td className="cell" style={cellStyle}>
                {typeof value === 'string' ? (
                  <Text margin="none" id={item.label}>
                    {value}
                  </Text>
                ) : (
                  value
                )}
              </td>
              <td>
                {item.favorite && (
                  <IconStar
                    scale={0.8}
                    stroke={theme.colors.black}
                    fill={theme.colors.black}
                  />
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </DetailsListStyled>
  );
}

export default DetailsList;
